import React, { useCallback } from 'react';

import { Box } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import { ActionButton, ActionButtonVariants } from 'components/action-button';
import { ActionStatus } from 'components/address-modal/types';
import { List, ListItem } from 'components/list';

import { useDeliveryAddressModalContext } from '../delivery-address-modal.context';

import {
  StyledAddressLine1,
  StyledAddressLine2,
  StyledModalHeader,
  StyledPostalCode,
} from './styled';

export const SaveDeliveryAddress: React.FC<{ close: VoidFunction }> = ({ close }) => {
  const { formatMessage } = useIntl();

  const { deliveryAddress, dispatchDeliveryAddressState } = useDeliveryAddressModalContext();

  const onClickOtherLocation = useCallback(() => {
    dispatchDeliveryAddressState({ type: ActionStatus.SAVE_DELIVERY_ADDRESS_OTHER_LOCATION });
  }, [dispatchDeliveryAddressState]);

  return (
    <>
      <StyledModalHeader aria-label={formatMessage({ id: 'saveDeliveryAddress' })}>
        {formatMessage({ id: 'saveDeliveryAddress' })}
      </StyledModalHeader>
      <Box margin="2rem 0 0 0" flexDirection="column">
        <List>
          <ListItem>
            <Box padding="1rem 3.5rem" flexDirection="column">
              <StyledAddressLine1 data-testid="save-address-addressline1">
                {deliveryAddress?.address.addressLine1}
              </StyledAddressLine1>
              <StyledAddressLine2 data-testid="save-address-addressline2">
                {deliveryAddress?.address.city} - {deliveryAddress?.address.state}
              </StyledAddressLine2>
              <StyledPostalCode data-testid="save-address-zip">
                {deliveryAddress?.address.zip}
              </StyledPostalCode>
            </Box>
          </ListItem>
        </List>
        <Box margin="1rem 0 1rem 0">
          <ActionButton
            fullWidth
            onClick={onClickOtherLocation}
            data-testid="yes-save-address"
            aria-label={formatMessage({ id: 'yes' })}
            variant={ActionButtonVariants.PRIMARY}
          >
            {formatMessage({ id: 'yes' })}
          </ActionButton>
        </Box>
        <ActionButton
          fullWidth
          onClick={close}
          aria-label={formatMessage({ id: 'no' })}
          data-testid="no-save-address"
          variant={ActionButtonVariants.OUTLINE}
        >
          {formatMessage({ id: 'no' })}
        </ActionButton>
      </Box>
    </>
  );
};
